module.exports = __webpack_public_path__ + "static/media/logotipo_hands.a1d08cfe.svg";